import React from "react";
import {
  PhoneIcon,
  MailIcon,
  LocationMarkerIcon,
  GlobeIcon,
  BriefcaseIcon,
} from "@heroicons/react/solid";
import CodingImage from "../assets/img/WhatsApp_Image_2024-06-08_at_12.38.24_3c112614-removebg-preview.png";

const AboutMe = () => {
  return (
    <section
      id="about"
      className="st-about-wrap py-20 bg-gradient-to-r from-blue-100 to-indigo-100"
    >
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h4 className="text-4xl font-bold text-primary mb-2">ABOUT ME</h4>
          <h2 className="text-2xl text-gray-700">ABOUT ME</h2>
        </div>

        <div className="flex flex-col lg:flex-row items-center justify-center lg:justify-start">
          <div className="lg:w-6/12 w-full mb-8 lg:mb-0">
            <div className="st-about-img-wrap">
              <img
                src={CodingImage}
                alt="CodingImage"
                className="st-about-img st-dynamic-bg st-bg rounded-lg shadow-lg"
              />
            </div>
          </div>

          <div className="lg:w-6/12 px-4">
            <div className="text-center lg:text-left">
              <h2 className="text-3xl font-bold text-primary mt-5">
                Hi👋, I'm Adebanjo Favour
              </h2>
              <h4 className="text-xl text-gray-700 mb-4 mt-2">
                Mern Stack Developer
              </h4>
              <div className="text-white-800 text-lg leading-relaxed">
                <p>
                  As a backend developer, I specialize in building robust and
                  efficient server-side applications that enhance digital
                  experiences. My expertise lies in developing scalable and
                  secure backend systems that support seamless user interactions
                  and drive business growth. I aim to create high-performance
                  solutions that ensure reliability, maintainability, and
                  optimal performance, ultimately facilitating a smooth and
                  engaging user experience.
                </p>
              </div>
              <ul className="text-gray-700 mt-6 space-y-4">
                <li className="flex items-center">
                  <PhoneIcon className="w-6 h-6 text-indigo-600 mr-3" />
                  <span className="font-semibold w-24">Phone:</span>
                  <span>+234 9167 638 933</span>
                </li>
                <li className="flex items-center">
                  <MailIcon className="w-6 h-6 text-indigo-600 mr-3" />
                  <span className="font-semibold w-24">Email:</span>
                  <span>favouradebanjo2@gmail.com</span>
                </li>
                <li className="flex items-center">
                  <LocationMarkerIcon className="w-6 h-6 text-indigo-600 mr-3" />
                  <span className="font-semibold w-24">From:</span>
                  <span>Nigeria</span>
                </li>
                <li className="flex items-center">
                  <GlobeIcon className="w-6 h-6 text-indigo-600 mr-3" />
                  <span className="font-semibold w-24">Language:</span>
                  <span>English</span>
                </li>
                <li className="flex items-center">
                  <BriefcaseIcon className="w-6 h-6 text-indigo-600 mr-3" />
                  <span className="font-semibold w-24">Freelance:</span>
                  <span>Available</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMe;
